import { assertUniqueName, clientPath, lpRequest } from '../../../../core/utils/lp-backend';
import { getHub } from './get-hub';

/**
 * `PUT /client/:cid/hubs {id, name, region_id}`. The route treats a `region_id` the hub is not already in as a move
 * and takes the hub out of every other region, so one of its current regions is sent to keep them all.
 */
export const editHub = async (hub_id: string, name: string): Promise<any> => {
  const [hub, hubs] = await Promise.all([getHub(hub_id), lpRequest('GET', clientPath('/hubs'))]);
  assertUniqueName(hubs || [], name, 'hub', hub_id);

  await lpRequest('PUT', clientPath('/hubs'), {
    body: { id: hub_id, name: name.trim(), region_id: hub.regions[0]?.id }
  });

  return getHub(hub_id);
};
